export const daContracts = [
  {
    id: 1,
    name: 'OFFER LETTER',
    path: '/templates/DSPOL.pdf',
  },
  {
    id: 2,
    name: 'HAND BOOK',
    path: '/templates/Handbook.pdf',
  },
  {
    id: 3,
    name: 'BIOMETRIC CONSENT',
    path: '/templates/BICF.pdf',
  },
  {
    id: 4,
    name: 'CONSENT TO AUTOMATED CALLS',
    path: '/templates/CACTMC.pdf',
  },
  {
    id: 5,
    name: 'E-SIGNATURE DISCLOSURES & CONSENT',
    path: '/templates/ESDC.pdf',
  },
  {
    id: 6,
    name: 'VEHICLE TECHNOLOGY CONSENT',
    path: '/templates/VTC.pdf',
  },
  {
    id: 7,
    name: 'BREAK WAIVER',
    path: '/templates/BreakWaiver.pdf',
  },
  //{
  //  id: 8,
  //  name: 'JURY DUTY',
  //  path: '/templates/JuryDuty.pdf',
  //},
];
// 1- Offer Letter, 2- Hand Book, 3- Biometric Consent, 4- Consent 4 Auto Calls, 5- E-Signature Disclosures and Consent, - 6 Vehicle Technology Consent 7- Break Waiver
export const daDoctype = [
  {
    id: 9,
    category: 'G',
    name: 'Certification',
  },
  {
    id: 10,
    category: 'G',
    name: 'Performance Award',
  },
  {
    id: 11,
    category: 'G',
    name: 'Other Document',
  },
];
export const daAdvanceFilter = [
  {
    id: 0,
    name: 'All',
  },
  {
    id: 1,
    name: 'Documents Not Completed',
  },
  {
    id: 2,
    name: 'Documents Completed',
  },
  {
    id: 3,
    name: 'Approaching Expiry',
  },
  {
    id: 4,
    name: 'License Expired',
  },
];
export const MAX_RECIPIENTS = 20;
